import { Controller } from '../utils/controller';

export default class extends Controller {
  readonly paths = {
    signIn: '/sign-in',
    signUp: '/sign-up'
  };

  readonly cssClass = {
    currentTab: 'elc-tabs__tab--current'
  };

  static targets = ['signInForm', 'signInTab', 'signUpForm', 'signUpTab'];

  declare signInTabTarget: HTMLElement;
  declare signInFormTarget: HTMLElement;
  declare signUpTabTarget: HTMLElement;
  declare signUpFormTarget: HTMLElement;

  toggleTab(event) {
    const { signIn, signUp } = this.paths;
    const { target } = event;
    const { parentElement } = target;
    const {
      signInFormTarget,
      signUpFormTarget,
      signInTabTarget,
      signUpTabTarget,
      patchUrl,
      cssClass: { currentTab }
    } = this;

    if (
      (target === signInTabTarget || parentElement === signInTabTarget) &&
      signInFormTarget.hidden
    ) {
      signInTabTarget.classList.add(currentTab);
      signUpTabTarget.classList.remove(currentTab);
      signInFormTarget.hidden = false;
      signUpFormTarget.hidden = true;
      patchUrl(signUp, signIn);
    } else if (
      (target === signUpTabTarget || parentElement === signUpTabTarget) &&
      signUpFormTarget.hidden
    ) {
      signInTabTarget.classList.remove(currentTab);
      signUpTabTarget.classList.add(currentTab);
      signInFormTarget.hidden = true;
      signUpFormTarget.hidden = false;
      patchUrl(signIn, signUp);
    }
  }

  /**
   * Patch URL.
   *
   * Provided a URL fragment (e.g., `/some-path`), replace it with another URL
   * fragment (e.g., `/another-path`).
   *
   * We currently update the browser's URL when toggling between tabs. The
   * objective is to accommodate hub-sites, which employ a location/language
   * suffix that we append to the domain (e.g., `/fr/fr` in
   * `https://www.darphin.eu/fr/fr/sign-in`).
   */
  patchUrl(oldPath: string, newPath: string): void {
    const url = window.location.href.replace(oldPath, newPath);
    history.pushState({}, '', url);
  }
}
